module.exports = __webpack_public_path__ + "static/media/Workday_Step3_Image3c.01608ac8.jpg";